<div [formGroup]="formGroupRef" class="approvals-checks">
    <mat-checkbox
        [class.approvals-checks__checkbox--invalid]="
            formGroupRef.get('cgu_acceptance').invalid && formGroupRef.get('cgu_acceptance').touched
        "
        [color]="'primary'"
        [formControlName]="'cgu_acceptance'"
        class="approvals-checks__checkbox theme-title theme-approval-check-background"
    >
        {{ cguTextParts[0] }}
        <a
            [href]="'https://manager.drcombe.ch/pdfcgu/' + languageCode + '/1/cgu_nouveau_compte.pdf'"
            rel="noopener noreferrer"
            target="_blank"
        >
            {{ cguTextParts[1] }}
        </a>
        {{ cguTextParts[2] }}
        <a href="https://infomaniak.com/gtl/rgpd.confidentiality" rel="noopener noreferrer" target="_blank">
            {{ cguTextParts[3] }}
        </a>
        {{ cguTextParts[4] }}
    </mat-checkbox>
    <mat-checkbox
        [color]="'primary'"
        [formControlName]="'mailing_acceptance'"
        class="approvals-checks__checkbox theme-title theme-approval-check-background"
    >
        {{ 'Je souhaite être informé des évolutions relatives aux services.' | transloco }}
    </mat-checkbox>
</div>
